// extracted by mini-css-extract-plugin
export default {"linkDestaque":"MenuLink_linkDestaque__cLWka","option":"MenuLink_option__1nwWM"};